import { Component, Input, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { AutoScrollDirective } from '../../../directives/auto-scroll.directive';
import { ScrollControlComponent } from '../scroll-control/scroll-control.component';

@Component({
  selector: 'app-page-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, AutoScrollDirective],
  templateUrl: './page-layout.component.html',
  styleUrls: ['./page-layout.component.scss']
})
export class PageLayoutComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() phoneNumber: string = '';
  @Input() additionalPhoneNumber: string = '';
  @Input() heroCtaLabel: string = '';
  @Input() heroCtaLink: string = '';
  @Input() heroImage: string = 'assets/images/default-hero.jpg';
  @Input() heroVideo: string = '';
  @Input() breadcrumbs: Array<{label: string, link?: string}> = [];
  @Input() prevPage?: {title: string, link: string};
  @Input() nextPage?: {title: string, link: string};
  @Input() autoScrollEnabled: boolean = true;
  @Input() scrollSpeed: number = 0.5;
  @Input() showPartners: boolean = true;
  @Input() partners: Array<{name: string, logo: string}> = [];

  headerScrolled = false;
  mobileMenuOpen = false;
  mobileDropdowns: { [key: string]: boolean } = {
    'assurances': false,
    'brokins': false
  };

  @HostListener('window:scroll')
  onWindowScroll() {
    this.headerScrolled = window.scrollY > 50;
  }

  constructor(private router: Router) {}

  ngOnInit(): void {
    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  ngOnDestroy(): void {
    window.removeEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll(): void {
    this.headerScrolled = window.scrollY > 50;
  }

  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
    // Reset dropdowns when closing menu
    if (!this.mobileMenuOpen) {
      this.mobileDropdowns = {
        'assurances': false,
        'brokins': false
      };
    }
  }

  toggleMobileDropdown(key: string): void {
    this.mobileDropdowns[key] = !this.mobileDropdowns[key];
  }

  scrollToSection(sectionId: string): void {
    this.router.navigate(['/'], { fragment: sectionId });
  }

  navigateToComparison(): void {
    this.router.navigate(['/devis']);
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  getPhoneLink(phoneNumber: string = this.phoneNumber): string {
    return 'tel:' + phoneNumber.replace(/\s/g, '');
  }
}
